import common from './modules/common'
import user from './modules/user';
import region from './modules/region';
import dataManagement from './modules/dataManagement'
import system from './modules/system';
import org from './modules/org';
import store from './modules/store';
//
const models = {common, user, region, dataManagement, system, org, store};

function model(modelName) {
  return new models[modelName]();
}
model.install = function (Vue) {
  Vue.prototype.$model = model;
  Vue.model = model;
};
export default model;

// ./src/model/index.js



// WEBPACK FOOTER //
// ./src/model/index.js